import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router, NavigationExtras } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import { Helpers } from "../../helpers";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class LogoutComponent implements OnInit {
    public navigate: string;
    public navigationExtras: NavigationExtras;
    id: any;
    constructor(private _router: Router,
        private _authService: AuthenticationService) {
    }

    ngOnInit(): void {
        Helpers.setLoading(true);

        // reset login status
        localStorage.clear();
        sessionStorage.clear();
        document.body.className = '';
        document.body.removeAttribute('style');
        document.documentElement.className = '';
        document.documentElement.removeAttribute('style');

        this._authService.logout();
        this._router.navigate(['/login']).then(() => {
            window.location.reload();
        });

    }


}


// WEBPACK FOOTER //
// ./src/app/auth/logout/logout.component.ts